import React, { FC } from 'react';
import { AnyFCO, FCOTypeHumanReadablePlural } from '../../../core/types/fcoTypes';
import { Card, Empty, FlexGroup, FlexItem, Tag } from '@lithos';

interface FCOMetadataCardProps {
  fco: AnyFCO;
}

const FCOTagsCard: FC<FCOMetadataCardProps> = ({ fco }) => {
  return (
    <Card title={'Tags'} data-testid="fco-tags-card">
      {fco.tags.length === 0 && (
        <FlexGroup direction="column" alignItems="center" justifyContent="center">
          <FlexItem>
            <Empty
              placement={'embedded'}
              actions={undefined}
              useCase={'empty'}
              title={<>No Tags Set</>}
              description={
                <>
                  {`Tags help you categorize and find your ${
                    fco?.fcoType ? FCOTypeHumanReadablePlural[fco.fcoType] : 'resources'
                  } with ease. To improve manageability and
                  searchability, consider adding relevant tags.`}
                </>
              }
            />
          </FlexItem>
        </FlexGroup>
      )}
      <FlexGroup gapSize="2" alignItems="flex-start" justifyContent="flex-start" wrap css={{ height: 'auto' }}>
        {fco.tags.map((tag) => {
          return (
            <FlexItem grow="0">
              <Tag category={tag.key} label={tag.value} size="s" icon={true} />
            </FlexItem>
          );
        })}
      </FlexGroup>
    </Card>
  );
};

export default FCOTagsCard;
